/*
* NAME: NoRides
* DESCRIPTION: Component, used there are no rides.
* */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

@translate(['no-rides'], { wait: true })
export class NoRides extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="c-no-rides">
        <img src="/images/icon-way.svg" alt="noRideIcon.svg" />
        <h1>
          {t('no-rides:heading')}
        </h1>
        <p>
          {t('no-rides:copy')}
        </p>
      </div>
    );
  }
}

NoRides.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/NoRides/index.js